/**
 * author andre.pitombeira
 */
export default function RedemptionService($http, RESOURCES) {
  var service;

  service = {
    retrieveRedemptions: retrieveRedemptions,
    retrieveRedemption: retrieveRedemption,
    updateRedemption: updateRedemption,
    searchRedemptions: searchRedemptions,
  };

  return service;

  function retrieveRedemptions(countryCode) {
    return $http.get(RESOURCES.REDEMPTION + '/' + countryCode);
  }

  function retrieveRedemption(id) {
    return $http.get(RESOURCES.REDEMPTION + '/' + id);
  }

  function updateRedemption(id, params) {
    return $http.put(RESOURCES.REDEMPTION + '/' + id, params);
  }

  function searchRedemptions(searchUrl) {
    return $http.get(RESOURCES.REDEMPTION + searchUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/redemptions/redemption.service.js